import React from 'react'
import { useDispatch } from 'react-redux'

import LKButton from '../LKButton'

import { openConfirmation } from './LKConfirmationModal'

const LKModalTrigger = ({ name, params, alias, disabled, permission, className, style, children }) => {
  const dispatch = useDispatch()

  function handleClick() {
    dispatch(openConfirmation(name, params))
  }

  return (
    <LKButton
      className={className}
      name={name}
      alias={alias}
      onClick={handleClick}
      disabled={disabled}
      permission={permission}
      style={style}
    >
      {children}
    </LKButton>
  )
}

export default LKModalTrigger
